import each from 'lodash/each';

export default ({
  cache,
  props,
}) => {
  const dependencies = cache.getDependencies({ props });
  let hasValidDependencies = true;
  each(dependencies, (dependency) => {
    if (!dependency) {
      hasValidDependencies = false;
    }
  });
  return hasValidDependencies;
};
